import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function OwlTwo(props) {
  return (
    <div className={styles.queryBox}>
      <CloseButton setSelected={props.setSelected} />
      <div className={styles.questions}>
        <p>
          I am an Owl, and what is going on, there is just not enough mice.
          Further more, there is not enough wooded areas for me to dwell and
          hunt. This is making it harder to hunt as most mice die on roads.
          Another thing is that some people seem to enjoy capturing us and
          taking us to these sort of shows against our wills.
        </p>
        <p>
          #OwlLivesMatter #MoreMice #StopCuttingDownTrees #owlwoods #leaveusbe
          #leaveusalone
        </p>
      </div>
    </div>
  );
}

export default OwlTwo;
